import request from '@api/request';

/**
 * 로그인/회원가입
 */

export const loginApi = async (params) =>
  await request({
    url: '/login',
    type: 'post',
    params,
  });
export const registerApi = async (params) =>
  await request({
    url: '/signup',
    type: 'post',
    params,
  });

export const uploadProfileApi = async (params) =>
  await request({
    url: '/users/upload-photo',
    type: 'post',
    params,
  });

export const userInfoApi = async (userId) =>
  await request({
    url: `/users/${userId}`,
    type: 'get',
  });

export const uploadUserInfoApi = async (params) =>
  await request({
    url: '/settings/update-user',
    type: 'put',
    params,
  });
